/* eslint-disable */
import React from 'react';

import { Element } from './styled';

const Checkbox = props => (
    <Element {...props} />
);

export default Checkbox;
